import { QueryClient } from '@tanstack/react-query';

/**
 * App-wide React Query client. Tuned for an admin app where the user hops
 * between menu screens constantly: cached data is shown INSTANTLY on revisit
 * (no full-screen spinner) and silently revalidated in the background.
 *
 * - staleTime 60s: a screen revisited within a minute doesn't refetch at all.
 * - gcTime 10min: cache survives navigating away and back.
 * - refetchOnWindowFocus off: no surprise reloads when alt-tabbing.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            gcTime: 10 * 60_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});
